<app-system-maintenance *ngIf="showMessage" (closeModal)="closeModal()"></app-system-maintenance>

<ng-container *ngIf="loading">
  <mapfre-loading></mapfre-loading>
</ng-container>

<ng-container *ngIf="!loading">
  <app-myinsurance-policy-renewal [expiringPolicyArray]="expiringPolicyArray"></app-myinsurance-policy-renewal>
  <ng-container *ngFor="let policy of activePolicyArray | sortByStatus: '-effDate'; let index = index;">
    <mapfre-card [singleCard]="false" [additionalClasses]="'shadow-container pb-0'">
      <app-policy-card-header [policy]="policy"></app-policy-card-header>

      <hr class="my-insurance-main-hr">
      <ng-container
        *ngIf="policy?.policynumber?.policyNumber.length === 6 || policy?.policynumber?.policyNumber.length === 10">
        <div class="alert-notice-wrapper">
          <app-bn-upcoming-payment-notice [policy]="policy"></app-bn-upcoming-payment-notice>
        </div>
      </ng-container>

      <app-renewal-notice [policy]='policy' [renewalPolicyList]='expiringLivoPolicyList' variant="policy-card">
      </app-renewal-notice>

      <div class="bn-notice-content alert-notice-wrapper"
        *ngIf="(policy?.policynumber?.policyNumber.length === 6 || policy?.policynumber?.policyNumber.length === 10)
                        && policy?.policyStatus === 'CANCELLED' && policy.calculatedBalanceDetails?.currentMinAmtDue > 0">
        <app-bn-imp-notice [policy]="policy"></app-bn-imp-notice>
      </div>

      <ng-container *ngIf="policy?.isDelinquency">
        <div class="bn-error-notice-sec mb-3">
          <app-bn-error-notice [amount]='policy?.exitDelinquencyAmount?.theAmount'
            [date]='policy?.policyCancellationEffectiveDate'
            [policyCancellationReason]='policy?.policyCancellationReason' [policy]='policy'>
          </app-bn-error-notice>
        </div>
      </ng-container>

      <ng-container *ngIf="policy?.hasAffinityGroup">
        <div class="bn-notice-content mt-4 mb-4" [ngClass]="{'mb-3 mt-3' : !isAcmic }">
          <app-affinity-notice [policy]="policy"></app-affinity-notice>
        </div>
      </ng-container>

      <div class="policy-info-row" [ngClass]="{'mb-3' : !isAcmic }">
        <ng-container
          *ngIf="policy?.policyType.includes('AUTO') || policy?.policyType.includes('GARAGE_KEEPER') ; else other_policy_type">
          <ng-container *ngIf="policy?.vehicle[0]?.vehicleIdentificationNumber?.Id !== ''; else other_policy_type ">
            <div [class.show-more-detail]="hideOrShow">
              <ng-container *ngFor="let vehicles of policy?.vehicle; last as last">
                <ng-container
                  *ngIf="!(policy?.policyType.includes('AUTO') && vehicles.vehicleIdentificationNumber?.Id === '')">
                  {{ vehicles.vehicle | titlecase }}<ng-container *ngIf="!last">, </ng-container>
                </ng-container>
              </ng-container>
            </div>
          </ng-container>
        </ng-container>

        <ng-template #other_policy_type>
          {{ policy?.residentialAddress?.streetName | titlecase }}, {{ policy?.residentialAddress?.city | titlecase }},
          {{ policy?.residentialAddress?.stateCode }},
          {{ policy?.residentialAddress?.zipCode?.code }}
        </ng-template>
      </div>

      <div class="policy-info-row" [class.show-more-detail]="hideOrShow" [ngClass]="{'mb-3' : !isAcmic }">
        <ng-container *ngFor="let insured of policy?.insured; last as last">
          {{insured['Insured Name'] | titlecaseHyphenatedValue }}<ng-container *ngIf="!last">, </ng-container>
        </ng-container>
      </div>

      <hr class="my-insurance-main-hr">
      <ng-container *ngIf="policy?.hasAffinityGroup">
        <app-last-payment [policy]='policy'></app-last-payment>
        <a mdbRipple class="see-details-btn mapfre btn mb-4"
          [routerLink]="['/my-insurance', policy?.policynumber.policyNumber, 'details']">
          {{ "SEE_DETAILS" | translate }}
        </a>
      </ng-container>

      <ng-container *ngIf="!policy?.hasAffinityGroup">
        <ng-container 
          *ngIf="policy?.pifDiscountInfo?.isPaidInFull 
                  || policy.calculatedBalanceDetails?.outstandingBalance !== 0 
                  || policy.calculatedBalanceDetails?.currentMinAmtDue !== 0"
        >
          <app-policy-billing-summary [policy]="policy">
            <app-pif-discount 
              *ngIf="policy?.pifDiscountInfo?.isPaidInFull && !policy?.pifDiscountInfo?.pifEligible"
              [policy]="policy" variant="policy-card"
            ></app-pif-discount>
          <div>
            <div class="policy-info-row">
            <ng-container
              *ngIf="!policy?.billingDetails[0] || (policy?.billingDetails[0] && policy.calculatedBalanceDetails?.outstandingBalance === 0)">
              <span class="label-col"
                [ngClass]="{'highlight-outstanding-bal': (policy.hasPriorYearBalance || policy.isUnderRenewal) && policy?.policynumber?.policyNumber.length === 10 && isAcmic}">
                <div class="d-flex align-items-center">
                  <div>
                    {{ 'OUTSTANDING_BALANCE' | translate}}*
                  </div>
                  <div class="ml-1">
                    <app-info-tooltip
                      #outBalTooltip0
                      *ngIf="outBalanceTooltipContentMap[policy.policynumber.policyNumber]"
                      [content]="outBalanceTooltipContentMap[policy.policynumber.policyNumber]"
                      [position]="'bottom'">
                    </app-info-tooltip>
                  </div>
                </div>
              </span>
              <span class="content-col highlight">
                $0.00
              </span>
            </ng-container>
            <ng-container
              *ngIf="policy?.billingDetails[0] && policy.calculatedBalanceDetails?.outstandingBalance > 0 && policy?.policynumber?.policyNumber.length === 6">
              <span class="label-col">
                <div class="d-flex align-items-center">
                  <div>
                    {{ 'OUTSTANDING_BALANCE' | translate}}*
                  </div>
                  <div class="ml-1">
                    <app-info-tooltip
                      #outBalTooltip6
                      *ngIf="outBalanceTooltipContentMap[policy.policynumber.policyNumber]"
                      [content]="outBalanceTooltipContentMap[policy.policynumber.policyNumber]"
                      [position]="'bottom'">
                    </app-info-tooltip>
                  </div>
                </div>
              </span>
              <span class="content-col highlight">
                {{ policy?.billingDetails[0]?.outstandingbalance | currency }}
              </span>
            </ng-container>
            <ng-container
              *ngIf="policy?.policynumber?.policyNumber.length > 6 && policy.calculatedBalanceDetails?.outstandingBalance > 0">
              <span class="label-col"
                [ngClass]="{'highlight-outstanding-bal': (policy.hasPriorYearBalance || policy.isUnderRenewal) && policy?.policynumber?.policyNumber.length === 10 && isAcmic}">
                <div class="d-flex align-items-center">
                  <div>
                    {{ 'OUTSTANDING_BALANCE' | translate}}*
                  </div>
                  <div class="ml-1">
                    <app-info-tooltip
                      #outBalTooltip10
                      *ngIf="outBalanceTooltipContentMap[policy.policynumber.policyNumber]"
                      [content]="outBalanceTooltipContentMap[policy.policynumber.policyNumber]"
                      [position]="'bottom'">
                    </app-info-tooltip>
                  </div>
                </div>
              </span>
              <span class="content-col highlight">
                {{ policy.calculatedBalanceDetails?.outstandingBalance | currency }}
              </span>
            </ng-container>
          </div>
        </div>

        <ng-container
          *ngIf="policy?.billingDetails && policy?.billingDetails[0] && (policy?.billingDetails[0]?.outstandingbalance !== 0 || policy?.billingDetails[0]?.amountStillDue > 0  || policy?.billingDetails[0]?.priorYearBalance > 0)">
          <app-policy-card-min-amount-due [policy]="policy"></app-policy-card-min-amount-due>

          <div class="pay-now-button" [ngClass]="{ 'display-inline': isAcmic }">
            <mapfre-button
                 *ngIf="policy?.billingDetails && (policy?.billingDetails[0]?.amountStillDue >= 0 || policy?.billingDetails[0]?.outstandingbalance > 0) && (policy?.days_left_to_expire > 21 || (policy?.policynumber.policyNumber.length === 10) || (policy?.policynumber.policyNumber.length === 6 && policy?.days_left_to_expire <= 21 && !policy?.livoPolicy))"
                  additionalClasses="basic primary no-padding x-small-btn paynow-btn pay-now-btn-sz billing-pay-now"
                  (click)="payNow(policy)">
                  {{ 'PAY_NOW' | translate }}
                </mapfre-button>

            <mapfre-button
              *ngIf="policy?.billingDetails && policy?.policyStatus === 'ACTIVE' && (policy?.billingDetails[0]?.amountStillDue >= 0 || policy?.billingDetails[0]?.outstandingbalance > 0) && policy?.days_left_to_expire <= 21 && policy?.policynumber.policyNumber.length === 6 && policy?.livoPolicy"
              additionalClasses="basic primary w100 h24 no-padding x-small-btn pay-now-modal  modal-medium modal-dialog center-on-page"
              (click)="showToast()">
              {{ 'PAY_NOW' | translate }}
            </mapfre-button>
          </div>
        </ng-container>
        </app-policy-billing-summary>
        <hr class="my-insurance-main-hr">
      </ng-container>

        <app-last-payment [policy]='policy'></app-last-payment>

        <app-dash-id-card [policy]='policy' [activePolicyArray]='activePolicyArray' [index]='index'>
        </app-dash-id-card>

        <div class="details-auto-enroll-container">
          <ng-container
            *ngIf="(policy?.policynumber?.policyNumber.length === 6 || (policy?.policynumber?.policyNumber.length > 6 && policy?.policyStatus === 'ACTIVE')) && (policy?.policyFlags.isEftEligible === 'Y' || policy?.policyFlags.isEdfEligible === 'Y' || policy?.policyFlags.isEbillEligible === 'Y')">
            <div class="auto-enroll-container">
              <div class="block-container mb-2" [ngClass]="{ 'col-656565': isAcmic,'col-9CB0BC': !isAcmic }">
                {{ 'SIMPLIFY_BILLING' | translate}}
              </div>

              <div class="biling-container lh-18" [ngClass]="{'acmic-billing-container':isAcmic}">
                <ng-container *ngIf="(policy?.policyFlags.isEftEligible === 'Y' && policy?.isNewPolicy && policy?.autoPay<=0 
                          || policy?.policyFlags.isEftEligible === 'Y' && !policy?.isNewPolicy) 
                        && policy?.policyStatus === 'ACTIVE' 
                        && !((policy?.policyCancellationReason 
                                && (policy?.policyCancellationReason.toLowerCase() === 'pay - non-payment of insurance premium'
                                  || policy?.policyCancellationReason.toLowerCase() === 'fpd - failure to pay deposit')
                                && policy?.policyFlags.isEft === 'UNENROLLED' ))">

                  <ng-container *ngIf="(policy?.policyFlags.isEftEligible === 'Y') 
                                        && ((policy?.billingDetails)[0]?.badCheckCount === 'N'
                                        || ((policy?.billingDetails)[0]?.badCheckCount === 'Y' && isAcmic))
                                        && (policy?.billingDetails)[0]?.mortageeFlag === 'N'">
                    <div class="label-col" [ngClass]="{'label-col-acmic':isAcmic}">
                      <ng-container *ngIf="isAutoPay">
                        <ng-container [ngSwitch]="policy?.policyFlags.isEft">
                          <ng-container *ngIf="isAcmic; else maAutopayMaintenence">
                            <div class="dash-check-img-row" *ngSwitchCase="'ENROLLED'">
                              <img src="assets/img/images/check-circle-new.svg" alt="payment convenience icon" />
                              <span [routerLink]="['/billing','autopay']" (click)="triggerDatalayer('Manage Autopay')" class="manage-autopay-paperless">{{ "MANAGE_AUTOPAY" | translate }}</span>
                            </div>
                            <a *ngSwitchCase="'UNENROLLED'" [routerLink] (click)="onShowMessage();triggerDatalayer('Enroll in Autopay')" class="btn-enroll">
                              {{ "ENROLL_IN_AUTOPAY" | translate }}
                            </a>
                            <a *ngSwitchCase="'ENROLLMENT-PENDING'" [routerLink] (click)="onShowMessage()"
                              class="btn-enroll">
                              {{ "PENDING_ENROLLMENT" | translate }} {{ "AUTOPAY" | translate }}
                            </a>
                          </ng-container>
                          <ng-template #maAutopayMaintenence>
                            <div class="dash-check-img-row" *ngSwitchCase="'ENROLLED'">
                              <img src="assets/img/images/icon-check.svg" alt="payment convenience icon" />
                              {{ "AUTOPAY" | translate }}
                            </div>
                            <a *ngSwitchCase="'UNENROLLED'" [routerLink] (click)="onShowMessage()" class="btn-enroll">
                              {{ "ENROLL_IN_AUTOPAY" | translate }}
                            </a>
                            <a *ngSwitchCase="'ENROLLMENT-PENDING'" [routerLink] (click)="onShowMessage()"
                              class="btn-enroll">
                              {{ "PENDING_ENROLLMENT" | translate }} {{ "AUTOPAY_MA" | translate }}
                            </a>
                          </ng-template>
                        </ng-container>
                      </ng-container>
                      <ng-container *ngIf="!isAutoPay">
                        <ng-container [ngSwitch]="policy?.policyFlags.isEft">
                          <ng-container *ngIf="isAcmic; else maAutopay">
                            <div class="dash-check-img-row" *ngSwitchCase="'ENROLLED'">
                              <img src="assets/img/images/check-circle-new.svg" alt="payment convenience icon" />
                              <span [routerLink]="['/billing','autopay']" (click)="triggerDatalayer('Manage Autopay')" class="manage-autopay-paperless">{{ "MANAGE_AUTOPAY" | translate }}</span>
                            </div>
                            <a class="btn-enroll" *ngSwitchCase="'UNENROLLED'" (click)="triggerDatalayer('Enroll in Autopay')" [routerLink]="['/billing','autopay']">
                              {{ "ENROLL_IN_AUTOPAY" | translate }}
                            </a>
                            <a *ngSwitchCase="'ENROLLMENT-PENDING'" [routerLink]="['/billing','autopay']"
                              class="btn-enroll">
                              {{ "PENDING_ENROLLMENT" | translate }} {{ "AUTOPAY" | translate }}
                            </a>
                          </ng-container>
                          <ng-template #maAutopay>
                            <div class="dash-check-img-row" *ngSwitchCase="'ENROLLED'">
                              <img src="assets/img/images/icon-check.svg" alt="payment convenience icon" />
                              {{ "AUTOPAY" | translate }}
                            </div>
                            <a *ngSwitchCase="'UNENROLLED'" [routerLink]="['/billing','autopay']" class="btn-enroll">
                              {{ "ENROLL_IN_AUTOPAY" | translate }}
                            </a>
                            <a *ngSwitchCase="'ENROLLMENT-PENDING'" [routerLink]="['/billing','autopay']"
                              class="btn-enroll">
                              {{ "PENDING_ENROLLMENT" | translate }} {{ "AUTOPAY_MA" | translate }}
                            </a>
                          </ng-template>
                        </ng-container>
                      </ng-container>
                    </div>
                  </ng-container>
                </ng-container>
                <ng-container
                  *ngIf="((policy?.policyType !== 'COMMERCIAL_AUTO') && (policy?.policyType !== 'GARAGE_KEEPER')); else commercialTemp">
                  <ng-container *ngIf="(policy?.policyFlags.isEdfEligible === 'Y')">
                    <div class="content-col">
                      <ng-container *ngIf="isPaperless">
                        <ng-container [ngSwitch]="true">
                          <ng-container *ngIf="isAcmic; else maPaperlessMaintenence">
                            <div class="dash-check-img-row"
                              *ngSwitchCase="policy?.policyFlags.isEdf ==='ENROLLED' || policy?.policyFlags.isEdf ==='TRUE'">
                              <img src="assets/img/images/check-circle-new.svg" alt="write icon" />
                              <span  class="manage-autopay-paperless" (click)="triggerDatalayer('Manage Paperless')">{{ "MANAGE_PAPERLESS" | translate }}</span>
                            </div>
                            <a *ngSwitchCase="policy?.policyFlags.isEdf ==='UNENROLLED' || policy?.policyFlags.isEdf==='FALSE'"
                              [routerLink] (click)="onShowMessage();triggerDatalayer('Enroll in Paperless')" class="btn-enroll">
                              {{ "ENROLL_IN_PAPERLESS" | translate }}
                            </a>
                            <a *ngSwitchCase="policy?.policyFlags.isEdf==='ENROLLMENT-PENDING'" [routerLink]
                              (click)="onShowMessage()" class="btn-enroll">
                              {{ "PENDING_ENROLLMENT" | translate }} {{ "PAPERLESS" | translate }}
                            </a>
                          </ng-container>
                          <ng-template #maPaperlessMaintenence>
                            <div class="dash-check-img-row"
                              *ngSwitchCase="policy?.policyFlags.isEdf ==='ENROLLED' || policy?.policyFlags.isEdf ==='TRUE'">
                              <img src="assets/img/images/icon-check.svg" alt="write icon" />
                              {{ "PAPERLESS" | translate }}
                            </div>
                            <a *ngSwitchCase="policy?.policyFlags.isEdf ==='UNENROLLED' || policy?.policyFlags.isEdf==='FALSE'"
                              [routerLink] (click)="onShowMessage()" class="btn-enroll">
                              {{ "ENROLL_PAPERLESS" | translate }}
                            </a>
                            <a *ngSwitchCase="policy?.policyFlags.isEdf==='ENROLLMENT-PENDING'" [routerLink]
                              (click)="onShowMessage()" class="btn-enroll">
                              {{ "PENDING_ENROLLMENT" | translate }} {{ "PAPERLESS" | translate }}
                            </a>
                          </ng-template>
                        </ng-container>
                      </ng-container>
                      <ng-container *ngIf="!isPaperless">
                        <ng-container *ngIf="isAcmic; else maPaperless">
                          <ng-container [ngSwitch]="true">
                            <div class="dash-check-img-row"
                              *ngSwitchCase="policy?.policyFlags.isEdf==='ENROLLED' || policy?.policyFlags.isEdf ==='TRUE'">
                              <img src="assets/img/images/check-circle-new.svg" alt="write icon" />
                              <span [routerLink]="['/billing', 'paperless']" (click)="triggerDatalayer('Manage Paperless')" class="manage-autopay-paperless">{{ "MANAGE_PAPERLESS" | translate }}</span>
                            </div>
                            <a *ngSwitchCase="policy?.policyFlags.isEdf==='UNENROLLED' || policy?.policyFlags.isEdf==='FALSE'"
                              [routerLink]="['/billing','paperless']" (click)="triggerDatalayer('Enroll in Paperless')" class="btn-enroll">
                              {{ "ENROLL_IN_PAPERLESS" | translate }}
                            </a>
                            <a *ngSwitchCase="policy?.policyFlags.isEdf==='ENROLLMENT-PENDING'"
                              [routerLink]="['/billing','paperless']" class="btn-enroll">
                              {{ "PENDING_ENROLLMENT" | translate }} {{ "PAPERLESS" | translate }}
                            </a>
                          </ng-container>
                        </ng-container>
                        <ng-template #maPaperless>
                          <ng-container [ngSwitch]="true">
                            <div class="dash-check-img-row"
                              *ngSwitchCase="policy?.policyFlags.isEdf==='ENROLLED' || policy?.policyFlags.isEdf ==='TRUE'">
                              <img src="assets/img/images/icon-check.svg" alt="write icon" />
                              {{ "PAPERLESS" | translate }}
                            </div>
                            <a *ngSwitchCase="policy?.policyFlags.isEdf==='UNENROLLED' || policy?.policyFlags.isEdf==='FALSE'"
                              [routerLink]="['/billing','paperless']" class="btn-enroll">
                              {{ "ENROLL_PAPERLESS" | translate }}
                            </a>
                            <a *ngSwitchCase="policy?.policyFlags.isEdf==='ENROLLMENT-PENDING'"
                              [routerLink]="['/billing','paperless']" class="btn-enroll">
                              {{ "PENDING_ENROLLMENT" | translate }} {{ "PAPERLESS" | translate }}
                            </a>
                          </ng-container>
                        </ng-template>
                      </ng-container>
                    </div>
                  </ng-container>
                </ng-container>

                <ng-template #commercialTemp>
                  <ng-container *ngIf="policy?.policyFlags.isEbillEligible === 'Y'">
                    <div class="content-col">
                      <ng-container *ngIf="isPaperless">
                        <ng-container [ngSwitch]="true">
                          <ng-container *ngIf="isAcmic; else commercialMaintenence">
                            <div class="dash-check-img-row"
                              *ngSwitchCase="policy?.policyFlags.isEbill==='ENROLLED' || policy?.policyFlags.isEbill ==='TRUE'">
                              <img src="assets/img/images/check-circle-new.svg" alt="write icon" />
                              {{ "E-BILL_TEXT" | translate }}
                            </div>
                            <a *ngSwitchCase="policy?.policyFlags.isEbill==='UNENROLLED' || policy?.policyFlags.isEbill ==='FALSE'"
                              [routerLink] (click)="onShowMessage()" class="btn-enroll">
                              {{ "NOT_ENROLLED_TEXT" | translate }} {{ "E-BILL_TEXT" | translate }}
                            </a>
                            <a *ngSwitchCase="policy?.policyFlags.isEbill==='ENROLLMENT-PENDING'" [routerLink]
                              (click)="onShowMessage()" class="btn-enroll">
                              {{ "PENDING_ENROLLMENT" | translate }} {{ "E-BILL_TEXT" | translate }}
                            </a>
                          </ng-container>
                          <ng-template #commercialMaintenence>
                            <div class="dash-check-img-row"
                              *ngSwitchCase="policy?.policyFlags.isEbill==='ENROLLED' || policy?.policyFlags.isEbill ==='TRUE'">
                              <img src="assets/img/images/icon-check.svg" alt="write icon" />
                              {{ "E-BILL_TEXT" | translate }}
                            </div>
                            <a *ngSwitchCase="policy?.policyFlags.isEbill==='UNENROLLED' || policy?.policyFlags.isEbill ==='FALSE'"
                              [routerLink] (click)="onShowMessage()" class="btn-enroll">
                              {{ "NOT_ENROLLED_TEXT" | translate }} {{ "E-BILL_TEXT" | translate }}
                            </a>
                            <a *ngSwitchCase="policy?.policyFlags.isEbill==='ENROLLMENT-PENDING'" [routerLink]
                              (click)="onShowMessage()" class="btn-enroll">
                              {{ "PENDING_ENROLLMENT" | translate }} {{ "E-BILL_TEXT" | translate }}
                            </a>
                          </ng-template>
                        </ng-container>
                      </ng-container>
                      <ng-container *ngIf="!isPaperless">
                        <ng-container [ngSwitch]="true">
                          <ng-container *ngIf="isAcmic; else commercialPaperless">
                            <div class="dash-check-img-row"
                              *ngSwitchCase="policy?.policyFlags.isEbill==='ENROLLED' || policy?.policyFlags.isEbill ==='TRUE'">
                              <img src="assets/img/images/check-circle-new.svg" alt="write icon" />
                              {{ "E-BILL_TEXT" | translate }}
                            </div>
                            <a *ngSwitchCase="policy?.policyFlags.isEbill==='UNENROLLED' || policy?.policyFlags.isEbill ==='FALSE'"
                              [routerLink]="['/billing','paperless']" class="btn-enroll">
                              {{ "NOT_ENROLLED_TEXT" | translate }} {{ "E-BILL_TEXT" | translate }}
                            </a>
                            <a *ngSwitchCase="policy?.policyFlags.isEbill==='ENROLLMENT-PENDING'"
                              [routerLink]="['/billing','paperless']" class="btn-enroll">
                              {{ "PENDING_ENROLLMENT" | translate }} {{ "E-BILL_TEXT" | translate }}
                            </a>
                          </ng-container>
                          <ng-template #commercialPaperless>
                            <div class="dash-check-img-row"
                              *ngSwitchCase="policy?.policyFlags.isEbill==='ENROLLED' || policy?.policyFlags.isEbill ==='TRUE'">
                              <img src="assets/img/images/icon-check.svg" alt="write icon" />
                              {{ "E-BILL_TEXT" | translate }}
                            </div>
                            <a *ngSwitchCase="policy?.policyFlags.isEbill==='UNENROLLED' || policy?.policyFlags.isEbill ==='FALSE'"
                              [routerLink]="['/billing','paperless']" class="btn-enroll">
                              {{ "NOT_ENROLLED_TEXT" | translate }} {{ "E-BILL_TEXT" | translate }}
                            </a>
                            <a *ngSwitchCase="policy?.policyFlags.isEbill==='ENROLLMENT-PENDING'"
                              [routerLink]="['/billing','paperless']" class="btn-enroll">
                              {{ "PENDING_ENROLLMENT" | translate }} {{ "E-BILL_TEXT" | translate }}
                            </a>
                          </ng-template>
                        </ng-container>
                      </ng-container>
                    </div>
                  </ng-container>
                </ng-template>
              </div>
            </div>
          </ng-container>
          <a mdbRipple [routerLink]="[
                '/my-insurance',
                policy?.policynumber.policyNumber,
                'details'
              ]" class="see-details-btn mapfre btn mb-4">
            {{ "SEE_DETAILS" | translate }}
          </a>
        </div>
      </ng-container>
    </mapfre-card>
  </ng-container>

  <div *ngIf="inactivePolicyArray.length > 0" [ngClass]="{'in-active-policies': !isAcmic}">
    <div class="inactive-policies-box" (click)="closeNonActiveCollapse('one')">
      {{ 'Inactive policies' | translate }}
      <i class="fa fa-chevron-down" *ngIf="!accordianWithMDB.one"></i>
      <i class="fa fa-chevron-up" *ngIf="accordianWithMDB.one"></i>
    </div>
    <div class="collapse-content padding-horizontal font-class" #one [class.fake-accourdian]="!accordianWithMDB.one">
      <ng-container *ngFor="let policy of inactivePolicyArray | sortByStatus: '-effDate'">
        <mapfre-card [singleCard]="false" [additionalClasses]="'shadow-container pb-0'">
          <app-policy-card-header [policy]="policy"></app-policy-card-header>
          <hr class="my-insurance-main-hr">

          <ng-container
            *ngIf="policy?.policynumber?.policyNumber.length === 6 || policy?.policynumber?.policyNumber.length === 10">
            <div class="alert-notice-wrapper">
              <app-bn-upcoming-payment-notice [policy]="policy"></app-bn-upcoming-payment-notice>
            </div>
          </ng-container>

          <ng-container *ngIf="(policy?.company?.companyName === 'ACIC' || policy?.company?.companyName === 'TW')
                                      && policy?.isDelinquency">
            <div class="deliquency bn-error-notice-sec">
              <app-bn-error-notice [policyCancellationReason]='policy?.policyCancellationReason' [policy]='policy'>
              </app-bn-error-notice>
            </div>
          </ng-container>

          <ng-container *ngIf="policy?.hasAffinityGroup">
            <div class="bn-notice-content mt-4 mb-4">
              <app-affinity-notice [policy]="policy"></app-affinity-notice>
            </div>
          </ng-container>

          <div class="policy-info-row" [ngClass]="{'mb-3' : !isAcmic }">
            <ng-container
              *ngIf="policy?.policyType.includes('AUTO') || policy?.policyType.includes('GARAGE_KEEPER') ; else other_policy_type">
              <ng-container
                *ngIf=" policy?.vehicle[0]?.vehicleIdentificationNumber?.Id !== ''; else other_policy_type ">
                <div [class.show-more-detail]="hideOrShow">
                  <ng-container *ngFor="let vehicles of policy?.vehicle; last as last">
                    {{ vehicles.vehicle | titlecase }}<ng-container *ngIf="!last">, </ng-container>
                  </ng-container>
                </div>
              </ng-container>
            </ng-container>
          </div>

          <ng-template #other_policy_type>
            {{ policy?.residentialAddress?.streetName | titlecase }}, {{ policy?.residentialAddress?.city | titlecase
            }},
            {{ policy?.residentialAddress?.stateCode }},
            {{ policy?.residentialAddress?.zipCode?.code }}
          </ng-template>


          <div class="policy-info-row" [class.show-more-detail]="hideOrShow" [ngClass]="{'mb-3' : !isAcmic }">
            <ng-container *ngFor="let insured of policy?.insured; last as last">
              {{insured['Insured Name'] | titlecaseHyphenatedValue}}<ng-container *ngIf="!last">, </ng-container>
            </ng-container>
          </div>

          <hr class="my-insurance-main-hr">

          <ng-container *ngIf="policy?.hasAffinityGroup">
            <app-last-payment [policy]='policy'></app-last-payment>
            <a mdbRipple class="see-details-btn mapfre btn mb-4"
              [routerLink]="['/my-insurance', policy?.policynumber.policyNumber, 'details']">
              {{ "SEE_DETAILS" | translate }}
            </a>
          </ng-container>
          <ng-container *ngIf="!policy?.hasAffinityGroup">
            <app-pif-discount 
              *ngIf="policy?.pifDiscountInfo?.isPaidInFull && !policy?.pifDiscountInfo?.pifEligible"
              [policy]="policy" variant="policy-card"
            ></app-pif-discount>
              <div>
                <div class="policy-info-row">
                <ng-container
                  *ngIf="!policy?.billingDetails[0] || (policy?.billingDetails[0] && policy.calculatedBalanceDetails?.outstandingBalance === 0)">
                  <span class="label-col"
                    [ngClass]="{'highlight-outstanding-bal': (policy.hasPriorYearBalance || policy.isUnderRenewal) && policy?.policynumber?.policyNumber.length === 10 && isAcmic}">
                    <div class="d-flex align-items-center">
                      <div>{{ 'OUTSTANDING_BALANCE' | translate}}*</div>
                      <div class="ml-1">
                        <app-info-tooltip
                          #outBalTooltip0
                          *ngIf="outBalanceTooltipContentMap[policy.policynumber.policyNumber]"
                          [content]="outBalanceTooltipContentMap[policy.policynumber.policyNumber]"
                          [position]="'bottom'">
                        </app-info-tooltip>
                      </div>
                    </div>
                  </span>
                  <span class="content-col highlight">
                    $0.00
                  </span>
                </ng-container>
                <ng-container
                  *ngIf="policy?.billingDetails[0] && policy.calculatedBalanceDetails?.outstandingBalance > 0 && policy?.policynumber?.policyNumber.length === 6">
                  <span class="label-col">
                    <div class="d-flex align-items-center">
                      <div>{{ 'OUTSTANDING_BALANCE' | translate}}*</div>
                      <div class="ml-1">
                        <app-info-tooltip
                          #outBalTooltip6
                          *ngIf="outBalanceTooltipContentMap[policy.policynumber.policyNumber]"
                          [content]="outBalanceTooltipContentMap[policy.policynumber.policyNumber]"
                          [position]="'bottom'">
                        </app-info-tooltip>
                      </div>
                    </div>
                  </span>
                  <span class="content-col highlight">
                    {{ policy?.billingDetails[0]?.outstandingbalance | currency }}
                  </span>
                </ng-container>
                <ng-container
                  *ngIf="policy?.policynumber?.policyNumber.length > 6 && policy.calculatedBalanceDetails?.outstandingBalance > 0">
                  <span class="label-col"
                    [ngClass]="{'highlight-outstanding-bal': (policy.hasPriorYearBalance || policy.isUnderRenewal) && policy?.policynumber?.policyNumber.length === 10 && isAcmic}">
                    <div class="d-flex align-items-center">
                      <div>{{ 'OUTSTANDING_BALANCE' | translate}}*</div>
                      <div class="ml-1">
                        <app-info-tooltip
                          #outBalTooltip10
                          *ngIf="outBalanceTooltipContentMap[policy.policynumber.policyNumber]"
                          [content]="outBalanceTooltipContentMap[policy.policynumber.policyNumber]"
                          [position]="'bottom'">
                        </app-info-tooltip>
                      </div>
                    </div>
                  </span>
                  <span class="content-col highlight">
                    {{ policy.calculatedBalanceDetails?.outstandingBalance | currency }}
                  </span>
                </ng-container>
              </div>
            </div>

            <ng-container
              *ngIf="policy?.billingDetails && policy?.billingDetails[0] && (policy?.billingDetails[0]?.outstandingbalance !== 0 || policy?.billingDetails[0]?.amountStillDue > 0 || policy?.billingDetails[0]?.priorYearBalance > 0) && policy.calculatedBalanceDetails?.outstandingBalance !== 0">
              <app-policy-card-min-amount-due [policy]="policy"></app-policy-card-min-amount-due>

              <div class="pay-now-button" [ngClass]="{ 'display-inline': isAcmic }">
                <mapfre-button
                  *ngIf="policy?.billingDetails && (policy?.billingDetails[0]?.amountStillDue >= 0 || policy?.billingDetails[0]?.outstandingbalance > 0) && (policy?.days_left_to_expire > 21 || (policy?.policynumber.policyNumber.length === 10) || (policy?.policynumber.policyNumber.length === 6 && policy?.days_left_to_expire <= 21 && !policy?.livoPolicy))"
                  additionalClasses="basic primary x-small-btn paynow-btn pay-now-btn-sz"
                  (click)="payNow(policy)">
                  {{ 'PAY_NOW' | translate }}
                </mapfre-button>

                <mapfre-button
                  *ngIf="policy?.billingDetails && policy?.policyStatus === 'ACTIVE' && (policy?.billingDetails[0]?.amountStillDue >= 0 || policy?.billingDetails[0]?.outstandingbalance > 0) && policy?.days_left_to_expire <= 21 && policy?.policynumber.policyNumber.length === 6 && policy?.livoPolicy"
                  additionalClasses="basic primary w100 h24 no-padding x-small-btn pay-now-modal  modal-medium modal-dialog center-on-page"
                  (click)="showToast()">
                  {{ 'PAY_NOW' | translate }}
                </mapfre-button>
              </div>
            </ng-container>
            <hr class="my-insurance-main-hr">

            <app-last-payment [policy]='policy'></app-last-payment>
            
            <div class="details-auto-enroll-container">
              <ng-container
                *ngIf="((policy?.policyType !== 'COMMERCIAL_AUTO') && (policy?.policyType !== 'GARAGE_KEEPER')); else commercialTemp">
                <ng-container
                  *ngIf="((policy?.policyFlags.isEdfEligible === 'Y') && (policy?.policynumber?.policyNumber.length === 6))">
                  <div class="auto-enroll-container">
                    <div class="block-container mb-2" [ngClass]="{ 'col-656565': isAcmic,'col-9CB0BC': !isAcmic }">
                      {{ 'SIMPLIFY_BILLING' | translate}}
                    </div>

                    <div class="biling-container" [ngClass]="{'acmic-billing-container':isAcmic}">
                      <ng-container [ngSwitch]="true">
                        <div class="dash-check-img-row"
                          *ngSwitchCase="policy?.policyFlags.isEdf==='ENROLLED' || policy?.policyFlags.isEdf ==='TRUE'">
                          <img src="assets/img/images/icon-check.svg" alt="write icon" />
                          {{ "PAPERLESS" | translate }}
                        </div>
                        <a *ngSwitchCase="policy?.policyFlags.isEdf==='UNENROLLED' || policy?.policyFlags.isEdf==='FALSE'"
                          [routerLink]="['/billing','paperless']" class="btn-enroll">
                          {{ "ENROLL_IN_PAPERLESS" | translate }}
                        </a>
                        <a *ngSwitchCase="policy?.policyFlags.isEdf==='ENROLLMENT-PENDING'"
                          [routerLink]="['/billing','paperless']" class="btn-enroll">
                          {{ "PENDING_ENROLLMENT" | translate }} {{ "PAPERLESS" | translate }}
                        </a>
                      </ng-container>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
              <ng-template #commercialTemp>
                <ng-container
                  *ngIf="((policy?.policyFlags.isEbillEligible === 'Y') && (policy?.policynumber?.policyNumber.length === 6))">
                  <div class="auto-enroll-container">
                    <div class="block-container mb-2" [ngClass]="{ 'col-656565': isAcmic,'col-9CB0BC': !isAcmic }">
                      {{ 'SIMPLIFY_BILLING' | translate}}
                    </div>

                    <div class="biling-container">
                      <ng-container [ngSwitch]="true">
                        <div class="dash-check-img-row"
                          *ngSwitchCase="policy?.policyFlags.isEbill==='ENROLLED' || policy?.policyFlags.isEbill ==='TRUE'">
                          <img src="assets/img/images/icon-check.svg" alt="write icon" />
                          {{ "E-BILL_TEXT" | translate }}
                        </div>
                        <a *ngSwitchCase="policy?.policyFlags.isEbill==='UNENROLLED' || policy?.policyFlags.isEbill ==='FALSE'"
                          [routerLink]="['/billing','paperless']" class="btn-enroll">
                          {{ "NOT_ENROLLED_TEXT" | translate }} {{ "E-BILL_TEXT" | translate }}
                        </a>
                        <a *ngSwitchCase="policy?.policyFlags.isEbill==='ENROLLMENT-PENDING'"
                          [routerLink]="['/billing','paperless']" class="btn-enroll">
                          {{ "PENDING_ENROLLMENT" | translate }} {{ "E-BILL_TEXT" | translate }}
                        </a>
                      </ng-container>
                    </div>
                  </div>
                </ng-container>
              </ng-template>

              <a mdbRipple [routerLink]="[
                      '/my-insurance',
                      policy?.policynumber.policyNumber,
                      'details'
                    ]" class="see-details-btn mapfre btn mb-4">
                {{ "SEE_DETAILS" | translate }}
              </a>
            </div>
          </ng-container>
        </mapfre-card>
      </ng-container>
    </div>
  </div>

  
  <div class="col-auto no-padding w-100-mobile w-100-tab desktop-hidden">
   <ng-container *ngIf="showLoyaltyBanner">
     <app-loyalty-banner></app-loyalty-banner>
   </ng-container>
 </div>
 <div class="pl-4 pr-4 mt-4">
    <app-add-missing-policy></app-add-missing-policy>
  </div>
  <div class="mt-4" *ngIf="showBillingMessage">
    <hr class="thin-hr-mb-24 mt-0">
    <div class="disclaimer-padding">
      <app-disclaimers [policies]='allPolicies'></app-disclaimers>
    </div>
  </div>
</ng-container>